import styled, { keyframes } from 'styled-components';
import theme from '../../utils/theme';

const slideDown = keyframes`
  0% {
      transform: translateY(-1.25rem); /* 20px */
      opacity: 0;
  }

  10% {
      transform: translateY(1.25rem);
      opacity: 1;
  }
  
  90% {
      transform: translateY(1.25rem);
      opacity: 1;
  }

  100% {
      transform: translateY(1.25rem);
      opacity: 0;
  }
`;
 
const ContenedorAlerta = styled.div`
  z-index: 200;
  width: calc(100% - 200px);
  position: fixed;
  margin-left: 180px !important;
  left: 0;
  top: 1.25rem; /* 20px */
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${slideDown} 4s ease forwards;

  @media screen and (max-width: 1024px) {
    margin-left: 0px !important;
    top: 3.5rem;
    width: 100%;
  }

  p {
    background-color: ${(props) => {
      if(props.tipo === 'error'){
        return theme.rojo;
      } else if (props.tipo === 'exito') {
        return theme.verdeEmail;
      } else {
        return '#000';
      }
    }};
    color: #fff;
    padding: 1.25rem 2.5rem !important; /* 20px 40px */
    border-radius: 0.31rem; /* 5px */
    box-shadow: 0px 0px 15px rgba(0,0,0,.1);
    text-align: center;
    font-size: 20px;
  }
`;

export {
  ContenedorAlerta
}